// Module
var code = "<div class=\"dms-grid-outer-wrapper dms-outer-element\">\n    <div class=\"dms-grid-wrapper dms-grid #=data.GridName#\"></div>\n</div>\n";
// Exports
export default code;